import { render, staticRenderFns } from "./LicenseLoginData.vue?vue&type=template&id=01bae155&scoped=true&"
import script from "./LicenseLoginData.vue?vue&type=script&lang=ts&"
export * from "./LicenseLoginData.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseLoginData.vue?vue&type=style&index=0&id=01bae155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bae155",
  null
  
)

export default component.exports